import api from '../../api/mas-athena';

const state = {
    meals: [],
    meal: []
};

const getters = {
    allMeals: state => state.meals,
    mealData: state => state.meal,
};

const actions = {
    async fetchMeals({ commit }) {
        const responce = await api.fetchMeals();

        commit('setMeals', responce.data.results);
    },
    async getMeal({ commit }, meal_id) {
        const response = await api.getMeal(meal_id)
        
        commit('setMeal', await response.data.results);
    }
};

const mutations = {
    setMeals: (state, meals) => {
        state.meals = meals;
    },
    setMeal: (state, meal) => {
        state.meal = meal;
    }    
};

export default {
    state,
    getters,
    actions,
    mutations
}